import { render, staticRenderFns } from "./contest-manage.vue?vue&type=template&id=645795f0&scoped=true"
import script from "./contest-manage.vue?vue&type=script&lang=js"
export * from "./contest-manage.vue?vue&type=script&lang=js"
import style0 from "./contest-manage.vue?vue&type=style&index=0&id=645795f0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645795f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('645795f0')) {
      api.createRecord('645795f0', component.options)
    } else {
      api.reload('645795f0', component.options)
    }
    module.hot.accept("./contest-manage.vue?vue&type=template&id=645795f0&scoped=true", function () {
      api.rerender('645795f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/research/contest-manage.vue"
export default component.exports